import React from 'react';
import { Navigation } from '../components/Navigation';
import { SmsHero } from '../components/SmsHero';
import { SmsWhyUs } from '../components/SmsWhyUs';
import { SmsServices } from '../components/SmsServices';
import { SmsFAQ } from '../components/SmsFAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function SmsPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-909">
      <Navigation data-id="element-910" />

      <main className="pt-[72px]" data-id="element-911">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SmsHero data-id="element-912" />
        <Consultation data-id="element-913" />
        <SmsWhyUs data-id="element-914" />
        <SmsServices data-id="element-915" />
        <SmsFAQ data-id="element-916" />
        <Testimonials data-id="element-917" />
        <Consultation data-id="element-918" />
      </main>

      <Footer data-id="element-919" />
      <CookieBanner data-id="element-920" />
      <FloatingContact data-id="element-921" />
    </div>;
}